module.exports = "accept-check"